import { all, fork } from 'redux-saga/effects'
import { watchLoadApp, watchLoadData } from './appSaga'
import { watchLoadTaxonomy } from './taxonomySaga'

// We only want to watch the 'watcher' sagas
export default function* root() {
  yield all([fork(watchLoadApp), fork(watchLoadData), fork(watchLoadTaxonomy)])
}
